var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1270,
    height: 116,
    viewBox: "0 0 1270 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.806 75.5551C109.849 71.7534 107.866 69.8393 103.909 66.0021C81.064 44.4238 58.6194 22.4733 36.5571 0.0974731C24.3743 0.0974731 12.1827 0.0974731 0 0.0974731C0 0.0974731 10.6088 4.01436 9.98628 15.8005C9.98628 49.0408 9.98628 82.29 9.97738 115.53C18.692 114.866 27.4067 114.219 36.1213 113.59C36.1302 87.5627 36.148 61.5358 36.1569 35.5089C56.1917 54.8452 76.52 73.8448 97.1594 92.5341C108.711 102.486 124.584 108.024 139.932 106.704C139.986 71.1685 140.03 35.633 140.084 0.0974731C131.36 0.0974731 122.636 0.0974731 113.904 0.0974731C113.877 25.2471 113.842 50.4055 113.815 75.5551H113.806Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.716 3.5447C280.496 1.24951 273.258 0.088623 264.009 0.088623C244.704 0.088623 225.407 0.088623 206.101 0.088623C196.711 0.088623 189.375 1.29382 184.084 3.72193C178.793 6.15004 175.084 9.72132 172.959 14.4269C170.834 19.1325 169.767 24.9458 169.758 31.8402C169.74 45.5759 169.713 59.3115 169.696 73.0472C169.687 80.0657 170.763 85.9056 172.941 90.5491C175.111 95.1927 178.846 98.5513 184.128 100.634C189.41 102.716 196.675 103.496 205.932 103.009C225.229 102.016 244.526 101.086 263.832 100.2C273.533 99.9426 285.138 98.2854 292.208 91.3201C297.374 86.2246 299.962 78.4795 299.98 68.6518C300.006 55.7403 300.024 42.8376 300.051 29.9261C300.06 23.4481 298.984 18.007 296.805 13.6028C294.635 9.19848 290.936 5.83988 285.716 3.5447ZM273.756 71.4521C273.756 75.1829 272.386 78.1693 269.674 80.4113C266.962 82.6622 263.156 83.8763 258.274 84.0624C242.747 84.6649 227.221 85.2941 211.695 85.9499C206.804 86.1626 202.945 85.2498 200.108 83.2116C197.271 81.1646 195.857 78.1427 195.866 74.1549C195.893 59.2052 195.92 44.2466 195.937 29.2969C195.937 25.5484 197.405 22.5354 200.312 20.2756C203.22 18.0248 207.053 16.8816 211.81 16.8461C227.337 16.7132 242.863 16.5892 258.389 16.474C263.147 16.4385 266.908 17.5728 269.683 19.868C272.457 22.1632 273.836 24.9458 273.827 28.2246C273.8 42.6338 273.773 57.0429 273.747 71.4521H273.756Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.524 12.7432C456.283 8.56042 452.272 5.3702 446.537 3.27883C439.103 0.567142 429.668 -0.141797 421.851 0.0886082C386.441 0.0886082 351.023 0.0886082 315.613 0.0886082C315.613 0.0886082 331.815 3.82826 331.797 13.328C331.744 41.3577 331.699 69.3962 331.646 97.4258C361.667 96.3447 391.679 95.4053 421.709 94.6078C430.041 94.1027 438.747 93.8545 446.617 90.8061C452.361 88.5818 456.345 85.3118 458.533 81.0759C460.72 76.84 461.814 71.5496 461.823 65.178L461.868 28.4107C461.868 22.1543 460.756 16.9259 458.515 12.7432H458.524ZM435.635 67.5086C435.492 75.0943 430.326 78.9846 420.144 79.2061C399.38 79.6669 378.616 80.1898 357.852 80.7569C357.888 59.1077 357.932 37.4674 357.968 15.8182C378.723 15.703 399.478 15.6055 420.242 15.5169C426.057 15.4903 430.095 16.5714 432.335 18.7514C434.576 20.9314 435.697 23.5633 435.697 26.6649C435.679 40.2765 435.661 53.897 435.635 67.5086Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.605 3.27883C598.385 1.14315 591.147 0.0797424 581.89 0.0797424C562.584 0.0797424 543.287 0.0797424 523.982 0.0797424C514.591 0.0797424 507.255 1.16087 501.964 3.31427C496.673 5.47653 492.965 8.64903 490.848 12.814C488.732 16.9879 487.665 22.1366 487.656 28.26C487.638 40.4538 487.629 52.6387 487.611 64.8324C487.611 71.0622 488.687 76.2729 490.866 80.4556C493.045 84.6383 496.779 87.74 502.07 89.7693C507.353 91.7898 514.636 92.7291 523.893 92.605C543.207 92.3569 562.522 92.162 581.836 92.029C591.333 92.1442 602.938 91.1872 610.212 84.789C615.361 80.2607 617.958 73.0915 617.958 63.9285C617.958 51.912 617.958 39.8866 617.958 27.8701C617.958 21.8353 616.873 16.7664 614.685 12.6545C612.506 8.54269 608.798 5.42336 603.578 3.28769L603.605 3.27883ZM591.787 65.8692C591.787 69.3076 590.426 72.0192 587.714 74.0131C585.002 76.007 581.196 77.0173 576.305 77.0438C560.761 77.1413 545.217 77.2742 529.673 77.4338C524.773 77.4869 520.905 76.5564 518.068 74.6512C515.223 72.7459 513.809 69.9988 513.809 66.4275C513.817 53.0286 513.835 39.6385 513.844 26.2396C513.844 22.881 515.303 20.1959 518.219 18.1931C521.127 16.1904 524.969 15.189 529.726 15.1801C545.261 15.1535 560.797 15.127 576.332 15.1004C581.089 15.1004 584.86 16.1638 587.634 18.2906C590.409 20.4263 591.796 23.005 591.796 26.018C591.796 39.3017 591.787 52.5855 591.778 65.8692H591.787Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.75 0.0797541C750.136 24.0773 736.45 48.0306 722.729 71.9749C709.292 47.9951 695.811 24.033 682.304 0.0797541C666.92 0.0797541 651.536 0.0797541 636.152 0.0797541C636.152 0.0797541 649.695 1.77234 649.695 12.5659C649.695 39.0005 649.695 65.435 649.704 91.8607C658.436 91.8784 667.169 91.905 675.901 91.9493C675.901 72.5244 675.892 53.0995 675.883 33.6657C676.675 33.6657 677.075 33.6657 677.866 33.6657C681.041 39.1068 682.633 41.8362 685.807 47.2862C694.157 62.1561 702.498 77.035 710.831 91.9227C720.435 92.0113 725.237 92.0645 734.84 92.1797C743.173 77.3629 751.496 62.5283 759.802 47.6938C762.887 42.2261 764.435 39.4967 767.52 34.0202C768.392 34.0202 768.828 34.0202 769.699 34.029C769.708 43.8921 769.717 53.7552 769.735 63.6183C769.744 73.3928 769.752 83.1673 769.761 92.9418C778.494 93.0836 787.226 93.2431 795.95 93.4115C795.914 62.2979 795.87 31.1844 795.834 0.0708923C785.136 0.0708923 774.43 0.0708923 763.732 0.0708923L763.75 0.0797541Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.82 0.0797424C850.692 31.4237 831.342 62.6347 811.841 93.7393C821.498 93.952 831.155 94.1736 840.812 94.4128C845.961 86.393 848.531 82.3697 853.68 74.2967C877.352 74.8018 901.023 75.369 924.695 76.0159C929.391 84.5143 931.738 88.7768 936.433 97.3549C946.615 97.736 956.797 98.1259 966.979 98.5247C947.914 65.5325 928.537 32.7263 908.893 0.0797424C895.875 0.0797424 882.847 0.0797424 869.829 0.0797424H869.82ZM860.794 58.638C869.935 44.025 879.032 29.3855 888.094 14.7193C888.885 14.7193 889.285 14.7193 890.077 14.7282C899.227 29.6868 908.306 44.6808 917.323 59.7103C898.48 59.3204 879.637 58.9571 860.794 58.638Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1091.32 61.0662C1095.48 59.0723 1098.69 56.5555 1100.93 53.5337C1103.17 50.503 1104.69 47.3836 1105.47 44.1846C1106.26 40.9855 1106.65 38.07 1106.64 35.4469C1106.64 34.0822 1106.64 33.4087 1106.64 32.044C1106.64 28.7031 1106.31 25.1762 1105.64 21.472C1104.97 17.7678 1103.48 14.2674 1101.16 10.9797C1098.84 7.69197 1095.26 5.04231 1090.43 3.02184C1085.61 1.00136 1078.96 0.0088501 1070.5 0.0088501H968.42C968.42 0.0088501 984.64 2.99525 984.658 13.6736C984.711 42.235 984.764 70.7963 984.818 99.3577C993.541 99.7299 1002.26 100.111 1011 100.51C1010.97 87.8286 1010.95 75.1474 1010.93 62.4574C1013.39 62.5283 1014.62 62.5638 1017.07 62.6347C1027.51 62.936 1032.68 64.3538 1039.6 66.9326C1047.95 70.0519 1056.56 74.4385 1064.09 79.2947C1078.02 88.4312 1091.87 97.6917 1105.64 107.067C1118.43 107.821 1131.22 108.592 1144.01 109.389C1121.48 93.695 1098.45 78.506 1074.97 64.2564C1081.71 64.1234 1087.16 63.0778 1091.32 61.0839V61.0662ZM1054.13 47.6318C1050.16 47.7115 1045.67 47.6938 1040.64 47.5786C1036.41 47.4811 1031.85 47.3216 1026.96 47.1001C1022.07 46.8785 1016.71 46.5329 1010.9 46.0721C1010.88 36.1736 1010.86 26.2839 1010.85 16.3853C1028.89 16.5182 1046.93 16.6689 1064.98 16.8195C1070.8 16.8727 1074.84 18.1931 1077.09 20.7985C1079.34 23.4038 1080.47 26.6029 1080.47 30.3691C1080.47 31.9908 1080.47 32.8061 1080.47 34.4278C1080.47 38.0788 1079.33 41.0298 1077.01 43.2629C1074.7 45.505 1070.57 46.9228 1064.83 47.2862C1061.7 47.4811 1058.09 47.5609 1054.13 47.6406V47.6318Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1243.82 0.0974848C1243.82 27.4891 1243.84 54.8807 1243.85 82.2723C1243.85 88.2274 1242.26 92.1885 1239.1 94.1204C1235.93 96.0611 1232.23 96.8853 1228.01 96.6283C1214.01 95.7687 1200.01 94.9357 1186.01 94.1381C1181.52 93.8811 1177.75 92.6671 1174.71 90.5225C1171.67 88.378 1170.15 84.3991 1170.14 78.5858C1170.11 52.4171 1170.08 26.2573 1170.06 0.088623C1161.33 0.088623 1152.61 0.088623 1143.88 0.088623C1143.91 25.6104 1143.94 51.141 1143.98 76.6628C1143.59 84.4611 1146.2 94.6167 1151.14 100.838C1157.08 108.308 1167.13 111.046 1176.32 111.472C1196.86 112.854 1217.39 114.307 1237.92 115.823C1246.11 116.434 1252.51 115.468 1257.13 112.863C1261.75 110.266 1265.06 106.403 1267.03 101.272C1269.01 96.1497 1270 90.0086 1270 82.8926C1270 55.2883 1270 27.6929 1270 0.088623C1261.28 0.088623 1252.55 0.088623 1243.82 0.088623V0.0974848Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_2",
    x: -8,
    y: -3.90253,
    width: 156.084,
    height: 131.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_101_2",
    x: 161.695,
    y: -3.91138,
    width: 146.355,
    height: 119.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_101_2",
    x: 307.613,
    y: -3.952,
    width: 162.255,
    height: 113.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_101_2",
    x: 479.611,
    y: -3.92026,
    width: 146.346,
    height: 108.536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_101_2",
    x: 628.152,
    y: -3.92911,
    width: 175.798,
    height: 109.341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_101_2",
    x: 803.841,
    y: -3.92026,
    width: 171.139,
    height: 114.445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_101_2",
    x: 960.42,
    y: -3.99115,
    width: 191.591,
    height: 125.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_101_2",
    x: 1135.88,
    y: -3.91138,
    width: 142.122,
    height: 131.911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1270,
    height: 116,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.17349de25b0e36eab4c674fe7b1092f6.svg";
export { ForwardRef as ReactComponent };